import React from 'react';
import useChart from '../../../../hooks/generic/charts/useChart';

const defaultChartOptions = {
  chart: { type: 'spline' },
  title: { text: null },
  credits: { enabled: false },
  plotOptions: {
    series: { marker: { enabled: false } }
  }
};

const SplineChart = (props) => {
  const [HighchartsComponent, highchartsOptions] = useChart({
    chartOptions: {
      defaultOptions: defaultChartOptions,
      primaryOptions: props.chartOptions
    },
    configs: props.configs
  });

  return(
    <HighchartsComponent {...highchartsOptions} callback={props.callbackFn}/>
  )
};

export default SplineChart;